// src/pages/Article.js
import React from "react";
import { useParams } from "react-router-dom";
import AuroraAlea from "./AuroraAlea";
import Synesthesia from "./Synesthesia";
import Epitaph from "./Epitaph"
import NightOut from "./NightOut";
import Vitruta from "./Vitruta"
import FashionWeek from "./FashionWeek";
import Robert from "./Robert";
import Giles from "./Giles";
import Sanchez from "./Sanchez";

export const Article = () => {
  const { id } = useParams();

  switch (id) {
    /* 👉 теперь id = 4 ведёт на статью Aurora & Alea */
    case "4":
      return <AuroraAlea />;
    case "2": 
      return <Synesthesia />;
    case "5": 
      return <Epitaph />;
    case "3": 
      return <NightOut />;
    case "6": 
      return <Vitruta />;
    case "7": 
      return <FashionWeek />;
    case "8": 
      return <Robert />;
    case "9": 
      return <Giles />;
    case "10": 
      return <Sanchez />;

    /* ➜ можно оставить старый путь, если где‑то ещё используется */
    // case "6":
    //   return <AuroraAlea />;

    default:
      return (
        <h1 style={{ padding: "2rem", textAlign: "center" }}>
          Статья не найдена
        </h1>
      );
  }
};
